/**
 * Terminology Map — translates internal soul system terms to universal user-facing terms
 * CRITICAL: No religious terminology (Esma, Mertebe, Gazzali, Tasavvuf, Ebced) shown to users
 */

export const MERTEBE_DISPLAY: Record<string, { tier: string; subtitle: string; color: string; bgColor: string }> = {
  NASUT:   { tier: 'Tier 1', subtitle: 'Practical Mind',    color: '#9CA3AF', bgColor: '#9CA3AF15' },
  MELEKUT: { tier: 'Tier 2', subtitle: 'Emotional Depth',   color: '#3B82F6', bgColor: '#3B82F615' },
  CEBERUT: { tier: 'Tier 3', subtitle: 'Analytical Mind',   color: '#8B5CF6', bgColor: '#8B5CF615' },
  LAHUT:   { tier: 'Tier 4', subtitle: 'Deep Awareness',    color: '#F59E0B', bgColor: '#F59E0B15' },
  HAHUT:   { tier: 'Tier 5', subtitle: 'Transcendent',      color: '#E5E7EB', bgColor: '#FFFFFF20' },
};

export const GAZZALI_DISPLAY: Record<string, { label: string; icon: string }> = {
  hikmet: { label: 'Wisdom',  icon: 'Brain' },
  secaat: { label: 'Courage', icon: 'Shield' },
  iffet:  { label: 'Balance', icon: 'Scale' },
  adalet: { label: 'Justice', icon: 'Gavel' },
};

export const HAL_DISPLAY: Record<string, string> = {
  tevbe:    'Beginning',
  zuhd:     'Focus',
  sabir:    'Patience',
  sukur:    'Gratitude',
  riza:     'Peace',
  tevekkul: 'Trust',
  muhabbet: 'Love',
};

// Esma → universal trait name mapping (top 50)
const ESMA_TRAIT_MAP: Record<string, string> = {
  'Er-Rahman': 'Compassion', 'Er-Rahim': 'Mercy', 'El-Melik': 'Leadership',
  'El-Kuddus': 'Purity', 'Es-Selam': 'Peace', "El-Mü'min": 'Trust',
  'El-Müheymin': 'Protection', 'El-Aziz': 'Strength', 'El-Cebbar': 'Restoration',
  'El-Mütekebbir': 'Greatness', 'El-Halik': 'Creativity', 'El-Bari': 'Organization',
  'El-Musavvir': 'Imagination', 'El-Gaffar': 'Forgiveness', 'El-Kahhar': 'Determination',
  'El-Vehhab': 'Generosity', 'Er-Rezzak': 'Provision', 'El-Fettah': 'Discovery',
  'El-Alim': 'Knowledge', 'El-Kabid': 'Discipline', 'El-Basit': 'Growth',
  'El-Hafid': 'Humility', 'Er-Rafi': 'Elevation', 'El-Muizz': 'Honor',
  'El-Müzill': 'Modesty', 'Es-Semi': 'Listening', 'El-Basir': 'Perception',
  'El-Hakem': 'Judgment', 'El-Adl': 'Fairness', 'El-Latif': 'Subtlety',
  'El-Habir': 'Awareness', 'El-Halim': 'Patience', 'El-Azim': 'Magnificence',
  'El-Gafur': 'Understanding', 'Eş-Şekur': 'Gratitude', 'El-Aliyy': 'Excellence',
  'El-Kebir': 'Significance', 'El-Hafiz': 'Memory', 'El-Mukit': 'Nourishment',
  'El-Hasib': 'Analysis', 'El-Celil': 'Nobility', 'El-Kerim': 'Kindness',
  'Er-Rakib': 'Vigilance', 'El-Mucib': 'Responsiveness', 'El-Vasi': 'Breadth',
  'El-Hakim': 'Wisdom', 'El-Vedud': 'Love', 'El-Mecid': 'Glory',
  'El-Bais': 'Inspiration', 'Eş-Şehid': 'Presence',
};

export function esmaToTraitName(esmaName: string): string {
  return ESMA_TRAIT_MAP[esmaName] || esmaName.replace(/^(El-|Er-|Es-|Eş-)/, '');
}

export function virtueScoreToColor(score: number): string {
  if (score >= 0.7) return '#10B981'; // green
  if (score >= 0.4) return '#F59E0B'; // amber
  return '#EF4444'; // red
}

export function getMertebeDisplay(mertebe: string) {
  return MERTEBE_DISPLAY[mertebe] || MERTEBE_DISPLAY.NASUT;
}

export function getHalDisplay(hal: string): string {
  return HAL_DISPLAY[hal] || 'Beginning';
}
